import Icon from 'veui/components/Icon'

Icon.register({
  'file-eml': {
    paths: [
      {
        fill: '#1d93eb',
        d: 'M27.7 9.81l-6.67-8A1.34 1.34 0 0020 1.33H6a2 2 0 00-2 2v25.33c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.04-.06-.55-.3-.85z'
      },
      {
        fill: '#79c7f2',
        d: 'M21.03 1.81A1.34 1.34 0 0020 1.33v7.33c0 1.1.9 2 2 2h6c0-.04-.06-.55-.3-.85z'
      },
      {
        fill: '#fff',
        d: 'M16 26.21c-3.5 0-5.68-2.54-5.68-6.63s2.17-6.63 5.68-6.63 5.68 2.54 5.68 6.63-2.17 6.63-5.68 6.63zm0-11.26c-3.2 0-3.69 2.9-3.69 4.63s.48 4.63 3.69 4.63 3.69-2.9 3.69-4.63-.48-4.63-3.69-4.63z'
      }
    ],
    width: '32',
    height: '32'
  }
})
